import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import I18n from 'i18n-js';
import DivButton from 'components/v2/div-button/div-button';
import { toggleAppbarAction } from 'actions/app-actions';
import css from './back-button.less';

class BackButton extends Component {
  componentDidMount() {
    const { toggleAppbar } = this.props;
    toggleAppbar();
  }

  componentWillUnmount() {
    const { toggleAppbar } = this.props;
    toggleAppbar();
  }

  render() {
    return (
      <DivButton {...this.props} className={css.backButton}>
        {`< ${I18n.t('v2.homepage.manualOrder.button.back')}`}
      </DivButton>
    );
  }
}

BackButton.propTypes = {
  toggleAppbar: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  toggleAppbar: toggleAppbarAction,
};

export default connect(null, mapDispatchToProps)(BackButton);
